/**
 * 文件（文档、图片）资源接口
 * @author： xuyd
 * @date：2024-05-05
 */
import request from "@/utils/request.js"

import {context} from '@/config/env.js'

const serviceModule = context.sunflower

export default {

  /**
   * 检索列表
   */
  searchImageList: (params) => {
    return request.post(serviceModule + "/file/image/searchImageList", params);
  },

  /**
   * 获取信息
   */
  getImageUrl: (id) => {
    let params = {id: id}
    return request.get(serviceModule + "/file/image/getImageUrl", {params});
  },

  /**
   * 上传图片
   *
   * @param params 参数
   * @param fileList 文件列表
   */
  uploadImage: (params, fileList) => {
    return request.uploadWithJson(serviceModule + "/file/image/uploadImage", {formData: params}, {fileList});
  },

  /**
   * 删除
   * @param id 文件id
   */
  deleteForm: (id) => {
    return request.get(serviceModule + "/file/image/deleteFile?id=" + id);
  },

  /////////////////////////////////////////////////////////////////////////////////////

}
